import cryptoJs from 'crypto-js';
import { LOCAL_STORAGE_KEY } from 'constants/LocalStorageKeys';

export const encryptedData = (data) => {
  return cryptoJs.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_SECRET_KEY)
    .toString()
    .trim();
};
export const decryptedData = (data) => {
  try {
    let _key = cryptoJs?.AES?.decrypt(data, process.env.REACT_APP_SECRET_KEY);
    let b = _key?.toString(cryptoJs?.enc?.Utf8);
    let a = null;
    if (b) {
      a = JSON.parse(b);
    }
    return a;
  } catch (error) {
    console.error(error);
  }
};

export const setDataInLocalStorage = (localStorageKeys, value) => {
  if (process.env.REACT_APP_MODE === 'Production') {
    removeDataFromLocalStorage(localStorageKeys);
    const encryptedKey = encryptedData(localStorageKeys);
    const encryptedValue = encryptedData(value);
    localStorage.setItem(encryptedKey, encryptedValue);
  } else {
    localStorage.setItem(localStorageKeys, JSON.stringify(value));
  }
};
export const getDataFromLocalStorage = (localStorageKeys) => {
  if (process.env.REACT_APP_MODE === 'Production') {
    var keys = Object.keys(localStorage),
      i = 0,
      key;

    for (; (key = keys[i]); i++) {
      let decryptedKey = decryptedData(key);
      if (decryptedKey === localStorageKeys) {
        let res = localStorage.getItem(key);
        return decryptedData(res);
      }
    }
    return null;
  } else {
    const item = localStorage.getItem(localStorageKeys);
    if (item === null || item === undefined || item === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(item);
    } catch (error) {
      console.error('Error parsing localStorage data:', error);
      return null;
    }
  }
};
export const removeDataFromLocalStorage = (removeKey) => {
  if (process.env.REACT_APP_MODE === 'Production') {
    var keys = Object?.keys(localStorage),
      i = 0,
      key;

    for (; (key = keys[i]); i++) {
      let decryptedKey = decryptedData(key);
      if (decryptedKey === removeKey) {
        localStorage.removeItem(key);
      }
    }
  } else {
    localStorage.removeItem(removeKey);
  }
};

export const removeAllDataFromLocalStorage = () => {
  localStorage.clear();
  return true;
};

export const getTokenFromLocalStorage = () => {
  const refreshToken = getDataFromLocalStorage(LOCAL_STORAGE_KEY?.refreshToken);
  const accessToken = getDataFromLocalStorage(LOCAL_STORAGE_KEY?.accessToken);

  const header = {
    accessToken: accessToken,
    refreshToken: refreshToken,
  };

  return JSON.stringify(header);
};
